import React, { useState } from 'react';
import { Button, Badge, Modal, LucideIcon, message, Typography } from './ot.jsx';
import { Card, CardContent } from './card';

 
const NOTIF_TYPE_CONFIG = {
  '系統':   { icon: 'Settings',    color: 'text-gray-500',   bg: 'bg-gray-100',   badge: 'gray'   },
  '公告':   { icon: 'Megaphone',   color: 'text-blue-500',   bg: 'bg-blue-100',   badge: 'blue'   },
  '提醒':   { icon: 'Bell',        color: 'text-amber-500',  bg: 'bg-amber-100',  badge: 'amber'  },
  '審核':   { icon: 'ClipboardCheck', color: 'text-green-500', bg: 'bg-green-100', badge: 'green'  },
  '警告':   { icon: 'AlertTriangle', color: 'text-red-500',  bg: 'bg-red-100',    badge: 'red'    },
  '訊息':   { icon: 'MessageSquare', color: 'text-purple-500', bg: 'bg-purple-100', badge: 'purple' },
};

const FILTER_OPTIONS = ['全部', '未讀', ...Object.keys(NOTIF_TYPE_CONFIG)];

const DEFAULT_STATS = [
  { value: 0, label: '全部通知', icon: 'Bell',         bgColor: 'bg-blue-50',  iconColor: 'text-blue-500'  },
  { value: 0, label: '未讀',     icon: 'BellRing',     bgColor: 'bg-amber-50', iconColor: 'text-amber-500' },
  { value: 0, label: '今日',     icon: 'Calendar',     bgColor: 'bg-green-50', iconColor: 'text-green-500' },
  { value: 0, label: '本週',     icon: 'CalendarDays', bgColor: 'bg-purple-50',iconColor: 'text-purple-500'},
];

const NotifRow = ({ notif, onView, onRead }) => {
  const cfg = NOTIF_TYPE_CONFIG[notif.type] || NOTIF_TYPE_CONFIG['系統'];
  return (
    <div
      className={`flex items-start gap-4 px-5 py-4 border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer ${!notif.read ? 'bg-blue-50/40' : ''}`}
      onClick={() => onView(notif)}
    >
      <div className={`w-10 h-10 rounded-xl ${cfg.bg} flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <LucideIcon name={cfg.icon} className={`w-5 h-5 ${cfg.color}`} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <span className={`text-sm font-semibold ${notif.read ? 'text-gray-600' : 'text-gray-900'}`}>{notif.title}</span>
          {!notif.read && <div className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />}
          <Badge color={cfg.badge}>{notif.type}</Badge>
        </div>
        <p className="text-xs text-gray-500 line-clamp-1">{notif.content}</p>
        <p className="text-xs text-gray-400 mt-1">{notif.time}</p>
      </div>
      <button
        onPointerDown={e => e.stopPropagation()}
        onClick={e => { e.stopPropagation(); onRead(notif.id); }}
        className="mt-1 p-1 text-gray-400 hover:text-blue-500 transition-colors"
        title={notif.read ? '已讀' : '標記已讀'}
      >
        <LucideIcon name={notif.read ? 'MailOpen' : 'Mail'} className="w-4 h-4" />
      </button>
    </div>
  );
};

const Name26 = ({
  notifications: propsNotifs = [],
  stats: propsStats = null,
  propsCategoryName = '通知',
}) => {
  const [notifs, setNotifs] = useState(propsNotifs.map(n => ({ ...n })));
  const [filter, setFilter] = useState('全部');
  const [viewNotif, setViewNotif] = useState(null);

  const displayStats = propsStats || DEFAULT_STATS;

  const handleRead = (id) => {
    setNotifs(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
  };

  const handleReadAll = () => {
    setNotifs(prev => prev.map(n => ({ ...n, read: true })));
    message.success('已全部標記已讀');
  };

  const handleView = (notif) => {
    handleRead(notif.id);
    setViewNotif(notif);
  };

  const filtered = notifs.filter(n => {
    if (filter === '全部') return true;
    if (filter === '未讀') return !n.read;
    return n.type === filter;
  });

  const unreadCount = notifs.filter(n => !n.read).length;

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Typography.Title level={3} style={{ margin: 0 }}>{propsCategoryName}中心</Typography.Title>
          {unreadCount > 0 && (
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">{unreadCount}</span>
          )}
        </div>
        <Button onClick={handleReadAll} icon={<LucideIcon name="MailOpen" className="w-4 h-4" />}>
          全部已讀
        </Button>
      </div>

      <div className="grid grid-cols-4 gap-4">
        {displayStats.map((stat, idx) => (
          <Card key={idx} className="border-0 shadow-sm">
            <CardContent className="p-4">
              <div className={`flex items-center gap-3 ${stat.bgColor} rounded-xl p-3`}>
                <LucideIcon name={stat.icon} className={`w-8 h-8 ${stat.iconColor}`} />
                <div>
                  <div className="text-2xl font-bold text-gray-800">
                    {stat.label === '未讀' ? unreadCount : stat.value}
                  </div>
                  <div className="text-sm text-gray-500">{stat.label}</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="border-0 shadow-sm overflow-hidden">
        {/* Filter tabs */}
        <div className="flex gap-1 px-4 pt-4 pb-0 flex-wrap">
          {FILTER_OPTIONS.map(opt => (
            <button
              key={opt}
              onClick={() => setFilter(opt)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors mb-1 ${filter === opt ? 'bg-blue-500 text-white' : 'text-gray-500 hover:bg-gray-100'}`}
            >
              {opt}
              {opt === '未讀' && unreadCount > 0 && (
                <span className="ml-1.5 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">{unreadCount}</span>
              )}
            </button>
          ))}
        </div>
        <CardContent className="p-0 mt-3">
          {filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 text-gray-400">
              <LucideIcon name="BellOff" className="w-12 h-12 mb-3" />
              <p className="text-sm">沒有{filter === '全部' ? '' : filter}通知</p>
            </div>
          ) : (
            filtered.map(notif => (
              <NotifRow key={notif.id} notif={notif} onView={handleView} onRead={handleRead} />
            ))
          )}
        </CardContent>
      </Card>

      <Modal
        open={!!viewNotif}
        title={viewNotif?.title}
        onCancel={() => setViewNotif(null)}
        footer={<Button onClick={() => setViewNotif(null)}>關閉</Button>}
        width={480}
      >
        {viewNotif && (
          <div className="space-y-4 pt-1">
            <div className="flex items-center gap-2">
              <Badge color={NOTIF_TYPE_CONFIG[viewNotif.type]?.badge}>{viewNotif.type}</Badge>
              <span className="text-xs text-gray-400">{viewNotif.time}</span>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 text-sm text-gray-700 leading-relaxed">
              {viewNotif.content}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Name26;
